import React from "react";

function HelpAndSupport() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="navIcon"
    >
      <path
        d="M16 25.2188C16.8629 25.2188 17.5625 24.5192 17.5625 23.6562C17.5625 22.7933 16.8629 22.0938 16 22.0938C15.1371 22.0938 14.4375 22.7933 14.4375 23.6562C14.4375 24.5192 15.1371 25.2188 16 25.2188Z"
        fill="white"
      />
      <path
        d="M16 0C7.15725 0 0 7.15606 0 16C0 24.8427 7.15606 32 16 32C24.8427 32 32 24.8439 32 16C32 7.15725 24.8439 0 16 0ZM16 29.5C8.53894 29.5 2.5 23.4621 2.5 16C2.5 8.53894 8.53794 2.5 16 2.5C23.4611 2.5 29.5 8.53794 29.5 16C29.5 23.4611 23.4621 29.5 16 29.5Z"
        fill="white"
      />
      <path
        d="M16 8.03125C13.243 8.03125 11 10.2743 11 13.0312C11 13.7216 11.5596 14.2812 12.25 14.2812C12.9404 14.2812 13.5 13.7216 13.5 13.0312C13.5 11.6528 14.6215 10.5312 16 10.5312C17.3785 10.5312 18.5 11.6528 18.5 13.0312C18.5 14.4097 17.3785 15.5312 16 15.5312C15.3096 15.5312 14.75 16.0909 14.75 16.7812V19.9062C14.75 20.5966 15.3096 21.1562 16 21.1562C16.6904 21.1562 17.25 20.5966 17.25 19.9062V17.8731C19.4041 17.3166 21 15.3568 21 13.0312C21 10.2743 18.757 8.03125 16 8.03125Z"
        fill="white"
      />
    </svg>
  );
}

export default HelpAndSupport;
